"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenVerifyError = void 0;
const common_1 = require("../common");
class AuthTokenVerifyError extends common_1.AuthError {
    constructor(tokenExpiredError) {
        super(tokenExpiredError.message);
        this.inner = tokenExpiredError.inner;
    }
}
exports.AuthTokenVerifyError = AuthTokenVerifyError;
//# sourceMappingURL=AuthTokenVerifyError.js.map